import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import GlobalOutlined from '@ant-design/icons/lib/icons/GlobalOutlined';
import { Dropdown } from 'antd';
import { investorLocalizationApi } from '@/api';
import CheckOutlined from '@ant-design/icons/lib/icons/CheckOutlined';
import { queryClient } from '@/app/QueryClientProvider';
import { investorActions } from '@/store/investor';
import { useCountries } from '@/hooks';
import { entitiesActions } from '@/store/entities';

export const LanguageInvestor = ({ languageId }) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { languages } = useCountries();

  useEffect(() => {
    try {
      if (languages) {
        const currentLang = languages?.find((i) => i.code === i18n.language.toUpperCase());

        if (currentLang.id !== languageId) {
          setLanguage({ key: currentLang.id });
        }
      }
    } catch (e) {
      console.error(e);
    }
  }, [languages]);

  const setLanguage = async (value) => {
    try {
      await investorLocalizationApi.setLanguage({ languageId: value.key });

      const newLang = languages.find((i) => i.id === value.key)?.code?.toLowerCase();
      i18n.changeLanguage(newLang).then(() => {
        localStorage.setItem('language', newLang);
        queryClient.refetchQueries();
        dispatch(investorActions.getInvestor(true));
      });
    } catch (e) {
      dispatch(entitiesActions.addToastInfo('Change language error'));
    }
  };

  if (!languages) return null;
  return (
    <Dropdown
      menu={{
        items: languages.map((item) => ({
          key: item.id,
          label: item.language,
          icon: i18n.language === item.code.toLowerCase() ? <CheckOutlined /> : null
        })),
        onClick: setLanguage
      }}
      trigger={'click'}
    >
      <div>
        <GlobalOutlined />
      </div>
    </Dropdown>
  );
};
